import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }
const _hoisted_4 = { style: {"text-transform":"lowercase"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlternativeEditor = _resolveComponent("AlternativeEditor")!

  return (_ctx.rm)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[3] || (_cache[3] = _createElementVNode("nav", { class: "navbar navbar-expand-sm navbar-light bg-light fixed-top" }, [
          _createElementVNode("div", { class: "container justify-content-end" }, [
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-lg btn-success",
              form: "editAlternativePageAlternativeForm"
            }, "Save Changes")
          ])
        ], -1 /* CACHED */)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", _hoisted_3, [
            _cache[0] || (_cache[0] = _createTextVNode("Edit ", -1 /* CACHED */)),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.rm.AlternativeLabel), 1 /* TEXT */)
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 30px"} }, null, -1 /* CACHED */)),
          _cache[2] || (_cache[2] = _createElementVNode("div", {
            class: "alert alert-warning",
            role: "alert"
          }, " Please remember to press Save Changes before refreshing this page and when the questionnaire is complete! ", -1 /* CACHED */)),
          _createVNode(_component_AlternativeEditor, {
            propRm: _ctx.rm.AlternativeEditor,
            propErrors: _ctx.errors,
            propFormId: "editAlternativePageAlternativeForm",
            onFormSubmit: _ctx.save
          }, null, 8 /* PROPS */, ["propRm", "propErrors", "onFormSubmit"])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}